module.exports = __webpack_public_path__ + "static/tear-02747f0b2f091cf93f1ac997f276b500.jpg";